export default __webpack_public_path__ + "static/media/about.499e5b20.png";